import { create } from 'zustand'

export const useSearchStore = create((set) => ({
    search: "",
    updateSearch: (newSearch) => set(() => ({ search: newSearch })),
    clearSearch: () => set({ search: "" }),
}))
